import React from 'react'

import { ReactComponent as DeclineIcon } from 'assets/svg/shared/decline.svg'

export function CancelCallButton(props) {
    const { onClick = () => {}, width = '60px', height = '60px', imgHeight = '13px', radius = '16px' } = props
    return (
        <button
            type="button"
            className="dialpad__cancel-call-btn d-flex justify-content-center align-items-center"
            style={{ width, height, borderRadius: radius }}
            onClick={onClick}
        >
            <DeclineIcon height={imgHeight} />
        </button>
    )
}
